export const CONFIG_NAME_MAX_LENGTH = 50;

export const SYSTEM_WIDE_USER_ID = 'statsbomb-shared';
export const PLACEHOLDER_SETTINGS_CONFIG_ID = 'default-team-config-id';

export const DEFAULT_PLAYER_DASHBOARD_ID = '9582325e-64f0-49a9-82a2-aea4dfdba6b4';
export const DEFAULT_TEAM_DASHBOARD_ID = '85126543-8922-4ca5-9d3d-a1e68fb51e27';
export const DEFAULT_GAME_DASHBOARD_ID = 'e11b0668-0a04-4258-a5ac-9e6ff980d927';
